import {api} from '../resources'
import {i18n} from '@/i18n'

export default {
    namespaced: true,
    state: {
        countries: [],
        cities: []
    },
    getters: {
        countriesSortedAlphabet: (state) => {
            const sortBy = `name_${i18n.locale}`
            return [...state.countries].sort((a, b) =>a[sortBy].localeCompare(b[sortBy]))
        },
        citiesSortedAlphabet: (state) => {
            const sortBy = `name_${i18n.locale}`
            return [...state.cities].sort((a, b) =>a[sortBy].localeCompare(b[sortBy]))
        }
    },
    actions: {
        getCountries({commit}) {
            return new Promise((resolve, reject) => {
                api.countries.get().then(res => {
                    if (res.body.success) {
                        commit('setCountries', res.body.data);
                        resolve()
                    }
                })
            })
        },
        getCities({commit}, code) {
            return new Promise((resolve, reject) => {
                api.cities.get({country_code: code}).then(res => {
                    if (res.body.success) {
                        commit('setCities', res.body.data);
                        resolve()
                    }
                })
            })
        },

    },
    mutations: {
        setCountries(state, data) {
            state.countries = data;
        },
        setCities(state, data) {
            state.cities = data;
        },
        clearCities(state) {
            state.cities = [];
        }
    }
}